export const SERVICE_CODE = 'DEAL' + '_LOSS_MOTIVE' + '_SERVICE';
